import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin';

export const SecureStorage = {
  async saveTokens(access: string, refresh: string) {
    await SecureStoragePlugin.set({ key: 'access_token', value: access });
    await SecureStoragePlugin.set({ key: 'refresh_token', value: refresh });
  },

  async getTokens() {
    try {
      const access = (await SecureStoragePlugin.get({ key: 'access_token' })).value;
      const refresh = (await SecureStoragePlugin.get({ key: 'refresh_token' })).value;
      return { access, refresh };
    } catch {
      return { access: null, refresh: null };
    }
  },

  async saveUser(user: any) {
    await SecureStoragePlugin.set({ key: 'user', value: JSON.stringify(user) });
  },

  async getUser() {
    try {
      const raw = (await SecureStoragePlugin.get({ key: 'user' })).value;
      return JSON.parse(raw);
    } catch {
      return null;
    }
  },

  async clear() {
    await SecureStoragePlugin.clear();
  }
};
